"use client";

import { FC, useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { DropdownOption } from "@finbackoffice/site-core";
import Button from "../button/Button";
import Translate from "../translate/Translate";
import Input, { OnChangeHandler } from "../input-field/Input";
import UniversalDeviceDropdown from "../universal-device-dropdown/UniversalDeviceDropdown";
import styles from "./pagination.module.sass";

interface IProps {
    items_per_page: number;
    page: number;
    total_pages: number;
    onPageChange: (val: number) => void;
    onPerPage: (val: string) => void;
}

const Pagination: FC<IProps> = ({ items_per_page, onPageChange, onPerPage, page, total_pages }) => {
    const [currentPage, setCurrentPage] = useState(String(page));
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const showPerPageNumbers = useMemo((): DropdownOption[] => {
        const result: DropdownOption[] = [
            { value: "5", label: "5" },
            { value: "10", label: "10" },
            { value: "20", label: "20" },
        ];

        return result;
    }, []);

    const handleChange: OnChangeHandler<false> = (val: string) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (parseInt(val)) {
            if (parseInt(val) <= total_pages) {
                setCurrentPage(val);
                timeoutRef.current = setTimeout(() => {
                    onPageChange(parseInt(val));
                }, 300);
            } else {
                setCurrentPage("1");
                onPageChange(1);
            }
        } else {
            setCurrentPage(val);
        }
    };

    useEffect(() => {
        if (String(page) !== currentPage) {
            setCurrentPage(String(page));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    return (
        <div className={classNames(styles.pagination, "pagination")}>
            <Translate tid="pagination_show" />
            <UniversalDeviceDropdown
                name="items_per_page"
                options={showPerPageNumbers}
                value={items_per_page.toString()}
                onChange={onPerPage}
                wrapperClassname={styles.dropdown}
            />

            <Input
                wrapperClassname={styles.pageField}
                type="text"
                name="page"
                onChange={handleChange}
                value={currentPage}
                inputMode="numeric"
            />
            <Translate tid="pagination_of" />
            {` ${total_pages}`}
            <Button
                type="button"
                variant="primary"
                onClick={() => onPageChange(page - 1)}
                className={styles.prevBtn}
                disabled={page === 1}
            />
            <Button
                type="button"
                variant="primary"
                onClick={() => onPageChange(page + 1)}
                className={styles.nextBtn}
                disabled={page >= total_pages}
            />
        </div>
    );
};
export default Pagination;
